import React from 'react';

const ZackatImage = ({ dt }) => {
  const { image } = dt;
  return (
    <img src={image} alt="Sample" />
  );
};
export default ZackatImage;
